import './MarketStatisticsAccordion.less';
import clsx from 'clsx';
import React, { useState } from 'react';
import { ArrowWhite } from '../../Arrows/Arrows';
import { isMobileChannel } from '../../../common/util';

function MarketStatisticsAccordion({ title, className, children }) {
    const [isExpanded, setIsExpanded] = useState(true);
    const isMobile = isMobileChannel();
    return (
        <>
            <div
                className={clsx('market-statistics-accordion mb-20', {
                    expanded: isExpanded,
                    'market-statistics-accordion-p-flex': !isMobile
                })}
            >
                <button
                    className={clsx(
                        'market-statistics-accordion-btn flex items-center px-20 py-10 full-width text-left',
                        className
                    )}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <span className="c-white fs-14 flex-1">{title}</span>
                    <ArrowWhite sizeX="16" sizeY="16" otherClassName={isExpanded ? 'arrow-up' : null} />
                </button>
                {isExpanded ? <div className="accordion-content">{children}</div> : null}
            </div>
        </>
    );
}
export default MarketStatisticsAccordion;
